<!-- 支持隐藏滚动条的 -->
<template>
  <div class="scrolltable">
    <div ref="th" class="thtable" :style="{'margin-right': scrollWidth + 'px'}">
      <slot></slot>
    </div>
    <div ref="tb" class="tbtable" :style="{'max-height': height ?height :''}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import ResizeObserver from 'resize-observer-polyfill';
export default {
  name: "scroll-table",
  props:["height"],
  data(){
    var resizeObserver = new ResizeObserver(this.resetScroll)
    return {
      resizeObserver,
      scrollWidth: 0,
    }
  },
  mounted(){
    this.resizeObserver.observe(this.$refs.tb);
  },
  watch:{
  },
  beforeDestroy(){
    this.resizeObserver.unobserve(this.$refs.tb)
  },
  methods: {
    resetScroll(entries){
      for (const entry of entries) {
        const { offsetWidth } = entry.target;
        const { clientWidth } = entry.target;
        this.scrollWidth = offsetWidth - clientWidth;
      }
    },
  },
}
</script>
<style>
  /*滚动表格*/
  .scrolltable{
    position: relative;
  }
  .thtable{
    left: 0;
    right: 0;
    /*background: #FFFFFF;*/
    height: 41.5px;
    overflow: hidden;
    /*margin-right: 15px;*/
    position: absolute;
    z-index: 8;
  }
  .tbtable{
    /*overflow-y: scroll;*/
    overflow-y: auto;
  }
  .tbtable thead{
    /*opacity: 0 !important;*/
  }
  .tbtable thead{
    /*border-right-color: rgba(0,0,0,0);*/
  }

  .page-header > .container{
    padding-bottom: 0;
  }
  .container{
    justify-content: center;
  }
</style>